import React, { Component } from 'react'
import Header from '../Header'
import './XXIVw.css'

class XXIVw extends Component {
  
    render () {
        return (
            <div>
                <Header />
                <div className="bodyXXIVw">
                    <p className="textXXIVw">A venir...</p>
                </div>
            </div>
        )
    }
}

export default XXIVw